import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HomeContact() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          sectionRef.current?.querySelectorAll('.hct-fade').forEach((el, i) => {
            setTimeout(() => {
              (el as HTMLElement).classList.add('opacity-100', 'translate-y-0');
              (el as HTMLElement).classList.remove('opacity-0', 'translate-y-8');
            }, i * 150);
          });
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-28 bg-[#1C2B22] relative overflow-hidden" ref={sectionRef}>
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20geometric%20pattern%20dark%20green%20texture%20subtle%20lines%20minimalist%20professional%20background&width=1920&height=600&seq=grainn-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-[#C9A878] text-xs tracking-[0.4em] mb-6 uppercase">
          / Free Consultation
        </p>
        <h2 className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
          まずは、<br />お気軽にご相談を。
        </h2>
        <div className="hct-fade opacity-0 translate-y-8 transition-all duration-700 w-16 h-px bg-[#C9A878]/50 mx-auto mb-8" />
        <p className="hct-fade opacity-0 translate-y-8 transition-all duration-700 text-white/60 text-base md:text-lg leading-relaxed mb-12 max-w-xl mx-auto">
          初回ご相談は無料です。WEBサイト制作・SNS運用・デジタルマーケティングについて、
          どんなご相談でもお気軽にどうぞ。
        </p>
        <div className="hct-fade opacity-0 translate-y-8 transition-all duration-700 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="bg-[#C9A878] text-[#1C2B22] px-10 py-5 rounded-full text-sm tracking-widest font-bold hover:bg-[#B8916A] transition-colors whitespace-nowrap"
          >
            無料相談を申し込む
          </Link>
          <Link
            to="/about"
            className="border border-white/40 text-white px-10 py-5 rounded-full text-sm tracking-widest hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            プロフィールを見る
          </Link>
        </div>
      </div>
    </section>
  );
}
